
import { Component, computed, inject } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';

import { useFirmwareStore } from '../+state/firmware-package/firmware-api.store';
import { AuthStore } from '../../auth';
import { RoleBasedAccessService } from '../../auth/role-based-access.service';
import { GlobalErrorService } from '../../error';
import { EnvironmentBuildInfo } from '../components/environment-build-info/environment-build-info';

import { UserMenu } from './auth/user-menu/user-menu';
import { AccessDenied } from './generics/access-denied/access-denied';
import { PageNotFound } from './generics/page-not-found/page-not-found';
import { PageNotFoundService } from './generics/page-not-found/page-not-found.service';
import { ServerErrorPageComponent } from './generics/server-error-page/server-error-page.component';

@Component({
  selector: 'remote-update-domain-base-layout',
  imports: [
    RouterModule,
    UserMenu,
    AccessDenied,
    ServerErrorPageComponent,
    PageNotFound,
    EnvironmentBuildInfo
],
  templateUrl: './base-layout.html',
  styleUrl: './base-layout.css'
})
export class BaseLayout {
  firmwareStore = inject(useFirmwareStore);
  authStore = inject(AuthStore);
  roleBasedAccessService = inject(RoleBasedAccessService);
  private router = inject(Router);
  private globalErrorService = inject(GlobalErrorService);
  private pageNotFoundService = inject(PageNotFoundService);

  isLoading = computed(() => this.firmwareStore.allPackages().loading);
  userInitials = this.authStore.userInitials();
  canAccessRoute = this.roleBasedAccessService.canAccessRoute();
  isServerError = this.globalErrorService.errorStatus;
  isPageNotFound = this.pageNotFoundService.isPageNotFound;

  menuItems = [
    { label: 'Devices', path: '/all-devices' },
    { label: 'Rollout Plans', path: '/rollout-plan' },
    { label: 'Firmware Packages', path: '/firmware-package' }
  ];
  isDetailsPage = false;
  backToPath = '/';
  backLabel = 'Back to Menu';
  detailsLabel = '';

  constructor() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.updateMenu();
    });
  }

  private updateMenu() {
    const url = this.router.url;

    if (url.includes('/details/')) {
      this.isDetailsPage = true;

      if (url.startsWith('/firmware-package/details')) {
        this.backToPath = '/firmware-package';
        this.backLabel = 'Firmware Packages';
        this.detailsLabel = 'Firmware package details view';
      } else if (url.startsWith('/all-devices/details')) {
        this.backToPath = '/';
        this.backLabel = 'Back to Devices';
        this.detailsLabel = 'Device update history';
      } else {
        this.backToPath = '/rollout-plan';
        this.backLabel = 'Rollout plan';
        this.detailsLabel = 'Rollout plan details view';
      }
    } else {
      this.isDetailsPage = false;
      this.backLabel = 'Back to Menu';
      this.detailsLabel = '';
    }
  }

  canAccessMenuRoute(path: string) {
    return this.roleBasedAccessService.canAccessRoute(path);
  }
}
